function updatePost() {

    _edit.on('submit', function(e) {
        e.preventDefault();
    }).validate({
        messages: {
            gender: _gendertext
        },
        rules: {
            email: {
                required: true,
                email: true,
            },
            firstname: {
                required: true,
            },
            lastname: {
                required: true,
            },
            birthday: {
                completeDate: true,
            },
            gender: {
                required: true,
            },
            country: {
                required: true,
            },
            password: {
                minlength: {
                    param: 8,
                    depends: function(element) {
                        return $(element).val().length > 0;
                    }
                },
                maxlength: 100,
            },
        },
        errorPlacement: function(error, element) {
            error.insertAfter(element);
        },
        submitHandler: function(form, event) {
            edit(form, this);
        }

    });

}

function editLoad(data) {

    var status = data.status;

    if (status != 'active') {

       //showResult(_emailverifydashboard, 'warning');

   }

}


function accountDeleteForm() {

    $('#delete-my-account form').on('submit', function(e) {
        e.preventDefault();
    }).validate({
        submitHandler: function(form) {
            $('#delete-my-account form button[type="submit"]').addClass('working disabled');
            $('#delete-my-account-form-response').html('');

            passport.delete()
                .done(function() {
                    var successtext = '<p>Your account has been deleted. Redirecting...</p>';
                    $('#delete-my-account-form-response').html(successtext);
                    $('#delete-my-account form').slideUp(500, 'easeInOutExpo');
                    $('#delete-my-account-form-response').slideDown(500, 'easeInOutExpo');
                    setTimeout(function() {
                        passport.logout().always(function() {
                            window.location.assign('/');
                        });
                    }, 2000);
                })
                .fail(function() {
                    $('#delete-my-account form button[type="submit"]').removeClass('working disabled');
                    showResult(errors.general, 'error');
                });
        }
    });

}



function processChangeEmailForm() {

    _changeemail.on('submit', function(e) {
        e.preventDefault();
    }).validate({
        submitHandler: function(form) {
            processChangeEmail(form);
        }
    });

}

function processChangeEmail() {

    var email = $('#email').val();
    var token = $('#token').val();
    var locale = $('#locale').val();

    return passport.processChangeEmail(token,email, upp_page.events, locale)

    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        if (jqXHR.status == 401) {
          //$(document).trigger('logged-out');
          showResult(errors.token, 'error');
      } else if (jqXHR.status == 409) {
          showResult(errors.duplicateemail, 'error');
      } else if (jqXHR.status == 404) {
          showResult(errors.token, 'error');
      } else {
          showResult(errors.token, 'error');
      }
  })
    .done(function(data, textStatus, jqXHR){
        showResult(_emailupdatedverified, 'success');
        $(document).trigger('rebuild');

        setTimeout(function() {
            document.location = upp_page.dashboard;
        }, 2000);

    })
}


function edit(form, validator) {

    var form_data = Object.fromEntries(new FormData(form).entries());

    var formdata = {
        firstname: form_data.firstname,
        lastname: form_data.lastname,
        email: form_data.email,
        birthday: getDateISO(form.elements.birthday),
        gender: form_data.gender,
        country: form_data.country
    };

    var actoken = getUrlParam('token');
    var locale = form_data.locale || $('#locale').val();
    var activateurl = upp_page.verify + '?token=' + actoken + '&email=' + formdata.email;

    if (form_data.password) {
        formdata.password = form_data.password;
    }

    passport.update(formdata, upp_page.change_email, locale)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');

        if (jqXHR.status == 400) {
            var responseJSON = jqXHR.responseJSON;

            if(responseJSON.errors)  {
                validator.showErrors(responseJSON.errors);
            }
        } else
        if (jqXHR.status == 401) {
            $(document).trigger('logged-out');
        } else
        if (jqXHR.status == 0) {
            showResult(_revalidate, 'warning');
        } else
        if (jqXHR.status == 409) {
            showResult(errors.duplicateemail, 'error');
        } else {
            showResult(errors.general, 'error');
        }

    })
    .done(function(formdata, textStatus, jqXHR){

         //log(jqXHR);


         if( $('#edit-form').hasClass('nc')) {

             if(actoken) {
                 log(activateurl);
                 document.location = activateurl;
             } else {
                 sendVerify(upp_page.verify);
                 $('#edit-form').removeClass('nc');
                 showResult(_verifysent, 'success');
                 return;
             }

         }


         if (_edit.hasClass('changed')) {
             _edit.removeClass('changed');
            //$('#password').val('');

            if (jqXHR.status == 200) {
                showResult(_accountupdated, 'success');
            }

            if (jqXHR.status == 202) {
                showResult(_emailupdatedstarted, 'warning');
            }



        } else {
            showResult(_nochanges, 'info');
        }

        if(formdata.password) {

            uppLogin(formdata.email, formdata.password).done(function () {
              //document.location.href = upp_page.dashboard;
              $(document).trigger('rebuild');
              $('#password').val('');
          });

        } else {
            $(document).trigger('rebuild');
        }

    })

}


function completeForms(data) {

    var nb = 0;
    var ng = 0;

    $('input[data-field], select[data-field]').each(function(){

        var el = $(this);
        var field = el.attr('data-field');
        var val = data[field];

        if(field == 'birthday') {
            if(val) { setDateFromISO('#birthday', val); } else { nb = 1; }
            return;
        }


        if(field == 'homeevent') {

        getEventJSON()
        .done(function(data) {
            $.each( data, function( key, v ) {

                if ( !v.web ) {
                    return;
                }

                if(val == v.passport.subscription_code) {
                    el.val(`${v.type} ${v.title}`);
                }

            });
        });

        return;
    }

    if (field == 'gender') {

        if (val) {
            $('#gender').val(val);
        } else {
            ng = 1;
        }

    } else {

        el.val(val);

    }

});

  // if dob or gender not completed
  if(ng || nb) {
      showResult(errors.pnc, 'warning');
      $('#edit-form').addClass('nc');
      if(nb) {
          $('#birthday').addClass('error');
      }
      if(ng) {
          $('li.gender select').after('<label id="gender-error" class="error" for="gender">Please select a gender option.</label>');
      }
  }

}


